import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';
import {
	ClientPortalLink,
	QuestionnaireData,
	ServerDataResponse
} from '@models/models';

@Injectable()
export class QuestionnairesDataProvider {
	constructor(private http: HttpClient) {}

	sendQuestionnaireEmail(data, isNew: boolean): Observable<any> {
		const url = isNew
			? '/protected/rest/job/questionnaire/save'
			: '/protected/rest/job/questionnaire/send';
		const { sendMessageData, storedFiles, uploadedFiles } = data;

		const formData: FormData = new FormData();

		for (const key in sendMessageData) {
			if (key !== 'attachmentsData') {
				formData.append(key, sendMessageData[key]);
			}
		}

		for (const key in storedFiles) {
			formData.append(`storedAttachments[${key}]`, storedFiles[key].id);
		}

		for (const key in uploadedFiles) {
			formData.append(`attachments[${key}]`, uploadedFiles[key]);
		}

		return this.sendQuestionnaireRequest(url, formData);
	}

	sendQuestionnaireRequest(
		url: string,
		formData: FormData
	): Observable<Object> {
		return this.http.post(url, formData);
	}

	getQuestionnarie(jobId: number, questId: number): Observable<any> {
		const url = `/protected/rest/jobs/${jobId}/questionnaire/${questId}/get/`;
		return this.http.get(url);
	}

	deleteQuestionnarie(jobId: number, questId: number): Observable<any> {
		const url = `/protected/rest/jobs/questionnaires/delete/${jobId}/${questId}/`;
		return this.http.post(url, {});
	}

	getQuestionnaireViewData(
		jobId: string,
		questionnaireId: string
	): Observable<QuestionnaireData> {
		const url = `/api/user/v2/job/${jobId}/questionnaire/${questionnaireId}/view`;
		return this.http
			.get(url)
			.pipe(
				map(
					(data: ServerDataResponse<QuestionnaireData>): QuestionnaireData =>
						data.data
				)
			);
	}

	getQuestionnairePreviewLink(url): Observable<ClientPortalLink> {
		return this.http
			.get(url)
			.pipe(
				map(
					(data: ServerDataResponse<ClientPortalLink>): ClientPortalLink =>
						data.data
				)
			);
	}

	deleteQuestionnaireV2(url: string): Observable<Object> {
		return this.http.delete(url);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./shared/services/questionnarie/questionnaires.data.service.ts